import './Schedule.css';
import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import {
  ReflexContainer,
  ReflexSplitter,
  ReflexElement
} from 'react-reflex';
import 'react-reflex/styles.css'
import { withTranslate } from 'react-redux-multilingual';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import Button from '@mui/material/Button';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import Pagination from '@mui/material/Pagination';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import WifiProtectedSetupIcon from '@mui/icons-material/WifiProtectedSetup';
import DangerousIcon from '@mui/icons-material/Dangerous';
import VisibilityIcon from '@mui/icons-material/Visibility';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import PendingActionsTwoToneIcon from '@mui/icons-material/PendingActionsTwoTone';

import ScheduleDialog from '../../blocks/ScheduleDialog/ScheduleDialog';
import HistoriesDetailsDialog from '../../blocks/HistoriesDetailsDialog/HistoriesDetailsDialog';

import {
    GetSchedules,
    CreateNewSchedule,
    UpdateSchedule,
    DisableSchedule,
    EnableSchedule,
    DeleteSchedule,
    RunSchedule,
    KillSchedule,
    GetHistories,
} from '../../../services/Schedule.service';
import { getEndpointURL } from '../../../services/config';

const io = require("socket.io-client");
const baseURL = getEndpointURL();

const innerHeight = window.innerHeight;

function Schedule(props) {
    const { translate, SnackbarAlert, ConfirmDialog } = props;
    const navigate = useNavigate();

    const [selected, setSelected] = React.useState([]);
    const [searchSchedule, setSearchSchedule] = React.useState("");
    const [pageCount, setPageCount] = React.useState(0);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const [schedules, setSchedules] = React.useState([]);
    const [histories, setHistories] = React.useState([]);
    const [openScheduleDialog, setOpenScheduleDialog] = React.useState(false);
    const [openHistoriesDetails, setOpenHistoriesDetails] = React.useState(false);

    const scheduleInforRef = React.useRef({});
    const socketRef = useRef();
    const hisInforRef = useRef({});
    const scriptIDRef = useRef();
    const scriptNameRef = useRef();
    

    const onInit = ({ backDrop }) => {
        if(backDrop) props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: true });
        GetSchedules(searchSchedule, rowsPerPage, page)
        .then(res => {
            // console.log(res)
            setPageCount(Math.ceil(res.data.datas[0][0]?.count / rowsPerPage));
            setSchedules(res.data.datas[1]);
        })
        .catch(err => {
            navigator("/signin");
        })
        .finally(() => {
            setTimeout(() => {
                props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: false });
            }, 1000);
        });
    }

    const isSelected = (id) => selected.indexOf(id) !== -1;

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked && selected.length === 0) {
            const newSelecteds = schedules.map((n) => n.ID);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleChangeRowsPerPage = (event) => {
        setPage(0);
        setRowsPerPage(event.target.value);
    };

    const handleChangePage = (event, value) => {
        setPage(parseInt(value) - 1);
    };

    const handleCloseScheduleDialog = () => {
        setOpenScheduleDialog(false);
    }

    const handleAddNewSchedule = () => {
        scheduleInforRef.current = {};
        setOpenScheduleDialog(true);
    }

    const handleUpdateSchedule = (schedule) => {
        scheduleInforRef.current = schedule;
        setOpenScheduleDialog(true);
    }

    const handleViewHistoriesDetails = (histories) => {
        hisInforRef.current.statusCd = histories.statusCd;
        hisInforRef.current.historiesID = histories.historiesID;
        scriptIDRef.current = histories.scriptID;
        scriptNameRef.current = histories.scriptName;
        handleOpenHistoriesDetails(true);
    }

    const handleCloseSnackbarAlert = () => {
        props.dispatch({ type: 'UPDATE_SNACKBARALERT', SnackbarAlert: { ...SnackbarAlert, open: false } });
    }

    const handleAgreeScheduleDialog = (schedule) => {
        // console.log(schedule);
        let event;
        setOpenScheduleDialog(false);
        if(!schedule.ID) {
            event = CreateNewSchedule(schedule);
        } else {
            event = UpdateSchedule(schedule);
        }
        event?.then(res => {
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: res?.data?.status,
                        message: translate(`${res?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
                onInit({ backDrop: true });
            }, 1000)
        })
        .catch(err => {
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            }, 1000)
        })
    }

    const handleClickButton = (title) => {
        props.dispatch({ 
          type: 'UPDATE_CONFIRMDIALOG', 
          ConfirmDialog: {
            open: true,
            title: translate(`${title}`),
            message: translate('confirmactionschedule', { action: `${translate(`${title}`)}`?.toLowerCase() }),
            buttonName: translate(`${title}`),
            onClose: () => handleCloseConfirmDialog(),
            onAgree: () => handleClickActions(title)
          } 
        });
    };

    const handleCloseConfirmDialog = () => {
        props.dispatch({ type: 'UPDATE_CONFIRMDIALOG', ConfirmDialog: {...ConfirmDialog, open: false} });
    }

    const handleClickActions = (title) => {
        let event;
        switch (title) {
            case "delete":
                if(selected.length > 0) {
                    handleCloseConfirmDialog();
                    event = DeleteSchedule(selected)
                }
                break;
            case "disable":
                if(selected.length > 0) {
                    handleCloseConfirmDialog();
                    event = DisableSchedule(selected)
                }
                break;
            case "enable":
                if(selected.length > 0) {
                    handleCloseConfirmDialog();
                    event = EnableSchedule(selected);
                }
                break;
            case "run":
                if(selected.length > 0) {
                    handleCloseConfirmDialog();
                    event = RunSchedule(selected.toString());
                }
                break;
            case "kill":
                if(selected.length > 0) {
                    handleCloseConfirmDialog();
                    event = KillSchedule(selected);
                }
                break;

        }
        event?.then(res => {
            props.dispatch({ 
                type: 'UPDATE_SNACKBARALERT', 
                SnackbarAlert: {
                    open: true,
                    severity: res?.data?.status,
                    message: translate(`${res?.data?.msg}`),
                    handleClose: () => handleCloseSnackbarAlert()
                } 
            });
            onInit({ backDrop: true });
        })
        .catch(err => {
            props.dispatch({ 
                type: 'UPDATE_SNACKBARALERT', 
                SnackbarAlert: {
                    open: true,
                    severity: err?.response?.data?.status,
                    message: translate(`${err?.response?.data?.msg}`),
                    handleClose: () => handleCloseSnackbarAlert()
                } 
            });
        })
    }

    const handleOpenHistoriesDetails = () =>  {
        setOpenHistoriesDetails(true);
    }
    const handleCloseHistoriesDetails = () => {
        setOpenHistoriesDetails(false);
    }

    useEffect(() => {
        setSelected([]);
    }, [schedules.length])

    useEffect(() => {
        setHistories([]);
        if(selected.length === 1) {
            GetHistories(selected?.toString())
            .then(res => {
                // console.log(res)
                setHistories(res.data.datas);
            })
        }
    }, [selected.length])

    useEffect(() => {
        const getData = setTimeout(() => {
            onInit({ backDrop: false });
        }, 500)
        return () => clearTimeout(getData)
    }, [searchSchedule, rowsPerPage, page])

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        socketRef.current = io(baseURL);
        socketRef.current.on("update-schedule-status", () => {
            onInit({ backDrop: true }); 
            if(selected.length === 1) {
                GetHistories(selected?.toString())
                .then(res => {
                    // console.log(res)
                    setHistories(res.data.datas);
                })
            }
        });
        return () => {
            socketRef.current.disconnect();
        };
    }, [searchSchedule, selected])

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        onInit({ backDrop: true });
    }, [])

    return (
        <Container maxWidth="xl">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Box className='shcedule-box' sx={{ height: (innerHeight - 64 - 18) }}>
                        <Grid item xs={12}>
                            <Box sx={{ 
                                    p: 1, 
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}>
                                <Box className='search-box'>
                                    <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
                                        <SearchIcon />
                                    </IconButton>
                                    <InputBase
                                        type="search"
                                        sx={{ ml: 1, flex: 1 }}
                                        placeholder={translate('search')}
                                        onChange={(e) => setSearchSchedule(e.target.value)}
                                    />
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                    {(selected.length > 0) && <Box>
                                        <Button variant="contained" disableElevation color='error' startIcon={<DeleteOutlineIcon />} onClick={() => handleClickButton('delete')}>{translate('delete')}</Button>
                                    </Box>}
                                    <Box>
                                        <Button variant="contained" disableElevation startIcon={<AddIcon />} onClick={handleAddNewSchedule}>{translate('addnew')}</Button>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                        <ReflexContainer orientation="horizontal">
                            <ReflexElement
                                minSize="200"
                                maxSize="1600"
                                sx={{ position: "relative" }}
                            >
                                <TableContainer sx={{ py: 1 }}>
                                    <Table stickyHeader size="small" sx={{ minWidth: 650 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell padding="checkbox">
                                                    <Checkbox 
                                                        color="primary"
                                                        indeterminate={selected.length > 0 && selected.length < schedules.length}
                                                        checked={schedules.length > 0 && selected.length === schedules.length}
                                                        onChange={handleSelectAllClick}
                                                    />
                                                </TableCell>
                                                <TableCell align="center">{translate('status')}</TableCell>
                                                <TableCell align="left">{translate('robotname')}</TableCell>
                                                <TableCell align="left">{translate('timezone')}</TableCell>
                                                <TableCell align="left">{translate('triggers')}</TableCell>
                                                <TableCell align="left">{translate('description')}</TableCell>
                                                <TableCell align="center">{translate('createduser')}</TableCell>
                                                <TableCell align="center">{translate('createddate')}</TableCell>
                                                <TableCell align="center">{translate('action')}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {schedules.map((row, index) => (
                                            <TableRow
                                                hover
                                                tabIndex={-1}
                                                key={row.ID}
                                            >
                                                <TableCell padding="checkbox">
                                                    <Checkbox 
                                                        color="primary"
                                                        checked={isSelected(row.ID)}
                                                        onClick={(event) => handleClick(event, row.ID)}
                                                    />
                                                </TableCell>
                                                <TableCell align="center">
                                                    {(row.statusCd === 0 || row.statusCd === 1) && <Chip 
                                                        size="small"
                                                        label={row.statusCd === 0 ? translate('ready') : row.statusCd === 1 ? translate('disabled') : ''}
                                                        color={row.statusCd === 0 ? 'info' : row.statusCd === 1 ? 'secondary' : ''}
                                                    />}
                                                    {row.statusCd === 2 && <WifiProtectedSetupIcon className="running-icon" />}
                                                </TableCell>
                                                <TableCell scope="row">
                                                    {row.name}
                                                    <IconButton className='edit-button'>
                                                        <BuildOutlinedIcon color='secondary' onClick={() => navigate(`/control-center/workspace/${row.scriptID}`)} />
                                                    </IconButton>
                                                </TableCell>
                                                <TableCell align="left">{row.timeZone}
                                                </TableCell>
                                                <TableCell align="left">{row.triggers}</TableCell>
                                                <TableCell align="left">{row.description}</TableCell>
                                                <TableCell align="center">{row.firstName}&nbsp;{row.lastName}</TableCell>
                                                <TableCell align="center">{row.createdDt}</TableCell>
                                                <TableCell align="center">
                                                    <IconButton className='edit-button'>
                                                        <EditOutlinedIcon color='secondary' onClick={() => handleUpdateSchedule({ ...row })} />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                {schedules?.length === 0 &&
                                <Box sx={{ position: "absolute", width: "100%", top: "30%", textAlign: "center" }}>
                                    <PendingActionsTwoToneIcon sx={{ fontSize: "200px", color: "#4152691a" }} />
                                    <Typography variant="h5" sx={{ color: "#9999998c", textAlign: "center" }}>
                                    {translate('createyouritemandstartexperimentingnow', { item: `${translate('schedule').toLowerCase()}` })}
                                    </Typography>
                                </Box>}
                            </ReflexElement>
                            <ReflexSplitter>
                                <Box className='control-bar'>
                                    <Box width="100%" display="flex" justifyContent="space-between" px={2}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <span>{translate('rowsperpage')}:</span>
                                            <FormControl sx={{ mr: 1 }} size="small">
                                                <Select
                                                    value={rowsPerPage}
                                                    onChange={handleChangeRowsPerPage}
                                                    displayEmpty
                                                    autoWidth
                                                    sx={{ "& > div": { padding: "5px 10px" }, "& > fieldset": { borderColor: "rgb(229, 234, 242)" } }}
                                                >
                                                    {[50, 100, 200].map(item => (
                                                        <MenuItem key={item} value={item}>{item}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        <Pagination 
                                            shape="rounded" 
                                            count={pageCount}
                                            page={page + 1}
                                            onChange={handleChangePage}
                                            color="primary" 
                                        />
                                    </Box>
                                </Box>
                            </ReflexSplitter>
                            <ReflexElement
                                maxSize="800"
                                size="256"
                            >
                                <ReflexContainer orientation="vertical">
                                    <ReflexElement>
                                        <TableContainer className='histories-table'>
                                            <Table stickyHeader size="small" sx={{ minWidth: 650 }} >
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{ minWidth: 200 }}>{translate('id')}</TableCell>
                                                        <TableCell align="center" sx={{ minWidth: 100 }}>{translate('status')}</TableCell>
                                                        <TableCell align="left">{translate('description')}</TableCell>
                                                        <TableCell align="left" sx={{ minWidth: 140 }}>{translate('startdatetime')}</TableCell>
                                                        <TableCell align="left" sx={{ minWidth: 140 }}>{translate('enddatetime')}</TableCell>
                                                        <TableCell align="center">{translate('view')}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                {histories.map((row) => (
                                                    <TableRow key={row.ID}>
                                                        <TableCell scope="row">
                                                            {row.historiesID}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Typography sx={{color: (row.statusCd === 0 ? 'rgb(208, 219, 10)' : row.statusCd === 1 ? 'success.main' : 'error.main')}} variant="subtitle2">
                                                            {row.statusCd === 0 ? translate('running') : row.statusCd === 1 ? translate('success') : translate('error')}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align="left" sx={{ maxWidth: 300 }}>
                                                            <Box>
                                                                {
                                                                    row.description
                                                                    ?.toString()
                                                                    ?.replace(/\\"/g,"\"")
                                                                    ?.replace(/\\'/g,"\'")
                                                                    ?.split('\\n')[0]
                                                                }
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell align="left">{row.startDateTime}</TableCell>
                                                        <TableCell align="left">{(row.statusCd !== 0) ? row.endDateTime : ''}</TableCell>
                                                        <TableCell align="center">
                                                            <IconButton size='small'>
                                                                <VisibilityIcon size='small' color='secondary' onClick={() => handleViewHistoriesDetails({...row})} />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </ReflexElement>
                                    <ReflexSplitter/>
                                    <ReflexElement
                                        size="220"
                                    >
                                        <Box sx={{ textAlign: "center" }}>
                                            <Box sx={{ height: 30, textAlign: "center", lineHeight: "30px", borderBottom: "1px solid rgb(249, 249, 249)" }}>{translate('actions')}</Box>
                                            <Box sx={{ "& button": { width: 110 }, display: "grid", gap: 1, p: 1 }}>
                                                {(selected.length === 1) && <Box>
                                                    <Button size='small' variant="contained" color='success' startIcon={<PlayCircleIcon />} onClick={() => handleClickButton('run')}>{translate('run')}</Button>
                                                </Box>}
                                                {(selected.length > 0) && <Box>
                                                    <Button size='small' variant="contained" color='warning' startIcon={<DangerousIcon />} onClick={() => handleClickButton('kill')}>{translate('kill')}</Button>
                                                </Box>}
                                                {(selected.length > 0) && <Box>
                                                    <Button size='small' variant="contained" color='info' startIcon={<CheckCircleIcon />} onClick={() => handleClickButton('enable')}>{translate('enable')}</Button>
                                                </Box>}
                                                {(selected.length > 0) && <Box>
                                                    <Button size='small' variant="contained" color='secondary' startIcon={<UnpublishedIcon />} onClick={() => handleClickButton('disable')}>{translate('disable')}</Button>
                                                </Box>}
                                            </Box>
                                        </Box>
                                    </ReflexElement>
                                </ReflexContainer>
                            </ReflexElement>
                        </ReflexContainer>
                    </Box>
                </Grid>
            </Grid>
            <ScheduleDialog 
                open={openScheduleDialog}
                scheduleInfor={scheduleInforRef.current}
                handleClose={handleCloseScheduleDialog}
                handleAgree={handleAgreeScheduleDialog}
            />
            <HistoriesDetailsDialog 
                mode={3}
                open={openHistoriesDetails}
                handleClose={handleCloseHistoriesDetails}
                hisInfor={hisInforRef.current}
                scriptID={scriptIDRef.current}
                scriptName={scriptNameRef.current}
            />
        </Container>
    );
}
function mapStateToProps(state) {
    return {
        BackDrop: state.BackDrop,
        SnackbarAlert: state.SnackbarAlert,
        ConfirmDialog: state.ConfirmDialog,
        BackDrop: state.BackDrop,
    }
}
export default connect(mapStateToProps)(withTranslate(Schedule));
